import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-favourite',
  templateUrl: './favourite.component.html',
  styleUrls: ['./favourite.component.scss']
})
export class FavouriteComponent implements OnInit {

  
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }


  docDetail:boolean = false;
  showmyDrive:boolean = false;
 

  showDocDetail(){
    this.docDetail = !this.docDetail
  }
  
  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }

  close() {
    this.dialog.closeAll();
  }

  
  createFolders(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef,{
      //panelClass: 'custom-modalbox'
    })
  }


}
